import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";

export interface OAuthResponse {
  accessToken: string;
  refreshToken: string;
  identifier: string;
  expiresIn: number;
  email: string;
  displayName: string;
}

export const oAuthApi = createApi({
  reducerPath: "oAuthApi",
  baseQuery: baseQuery("oauth"),
  tagTypes: ["OAuth"],
  endpoints: (builder) => ({
    submitGoogleResponse: builder.mutation<ApiResponse<OAuthResponse>, any>({
      query: (body) => ({
        url: "googleAuthCodeFlowResponseHandler",
        method: "GET",
        params: body,
      }),
    }),
  }),
});
